import type { FC } from "react";
import React from "react";
import {
  Body,
  Box,
  Card,
  Tab,
  Tabs,
} from "@edreamsodigeo/prisma-design-system";
import { useTranslation } from "@edreamsodigeo/frontend-core";

import { SubscriptionMultiOfferFares } from "~/pages/MembershipPageMobile/SubscriptionMultiOffer/versions/common/contract";
import type { LightboxOfferDeviceProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/contracts";
import { LightboxOfferSubscriptionSingle } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferSubscriptions/LightboxOfferSubscriptionSingle";
import { LightboxOfferSubscriptionWrapper } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxOffer/LightboxOfferSubscriptions/LightboxOfferSubscriptionWrapper";

const LightboxOfferMobile: FC<LightboxOfferDeviceProps> = ({
  basicOffer,
  plusOffer,
  offerTab,
  onTabChange,
  text,
}) => {
  const { t } = useTranslation();
  const isActiveTabPlus = offerTab === SubscriptionMultiOfferFares.PLUS;
  const isActiveTabBasic = offerTab === SubscriptionMultiOfferFares.BASIC;

  return (
    <Box sx={{ top: "-45px", zIndex: 10, position: "relative" }} px={"1x_big"}>
      <Card p={0}>
        <Tabs value={offerTab} onChange={onTabChange}>
          <Tab
            key={`lightbox-offer-tab-plus`}
            id={`lightbox-offer-tab-plus`}
            title={
              <Body
                type={"small"}
                color={isActiveTabPlus ? "neutral.90" : "neutral.70"}
              >
                {t("lightboxPrimeRevampDesktop.plan.primeplus")}
              </Body>
            }
            value={SubscriptionMultiOfferFares.PLUS}
            subtitle={
              <LightboxOfferSubscriptionWrapper>
                <LightboxOfferSubscriptionSingle
                  offer={plusOffer}
                  text={text.textPlus}
                  isActiveTab={isActiveTabPlus}
                />
              </LightboxOfferSubscriptionWrapper>
            }
            disabled={false}
          />
          <Tab
            key={`lightbox-offer-tab-base`}
            id={`lightbox-offer-tab-base`}
            title={
              <Body
                type={"small"}
                color={isActiveTabBasic ? "neutral.90" : "neutral.70"}
              >
                {t("lightboxPrimeRevampDesktop.plan.primebasic")}
              </Body>
            }
            subtitle={
              <LightboxOfferSubscriptionWrapper>
                <LightboxOfferSubscriptionSingle
                  offer={basicOffer}
                  text={text.textBasic}
                  isActiveTab={isActiveTabBasic}
                />
              </LightboxOfferSubscriptionWrapper>
            }
            value={SubscriptionMultiOfferFares.BASIC}
            disabled={false}
          />
        </Tabs>
      </Card>
    </Box>
  );
};

export default LightboxOfferMobile;
